import { render, staticRenderFns } from "./income_summary.vue?vue&type=template&id=ba86d7ce&"
import script from "./income_summary.vue?vue&type=script&lang=js&"
export * from "./income_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports